import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Old Remix loaders refetched on navigation; TanStack defaults are
            // close enough. Tune per-query as screens are migrated.
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});
